import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IwsUpload from '@comp/upload/IwsUpload';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, httpAction } from '@api/manage';
import { queryFileList, queryInspectionTree, queryTemplateTowList, queryUserTreeList, queryDepartTreeList } from '@api/api';
import moment from 'moment';
import pick from 'lodash.pick';
import MapGetPoint from '@/components/Map/MapGetPoint';
/* DataSource 定义表格数据源数组*/

export default {
  name: 'InspectionRecordModal',
  mixins: [ModalFormMixin, JeecgListMixin],
  // 导入地图
  data: function data() {
    return {
      showState: false,
      showResult: false,
      type: 0,
      //0 新增 1 审核  2 负责人处理  3查看
      handledDataState: false,
      columns: [],
      deptTree: [],
      //部门信息

      /* 站点名称*/
      siteName: '',

      /* 站点ID*/
      // 图片相关 图片id
      imgId: '',
      // 是否显示图片
      showImgModal: false,
      // 人员信息
      userTree: [],
      title: '安全生产',
      form_fields: ['category', 'name', 'departId', 'verifyUser', 'responsible', 'workUser', 'accompanyUser', 'time', 'content', 'verifyState', 'verifyComments', 'addr', 'safeEducation', 'feedback'],
      form_fields_time: ['time'],
      validatorRules: {
        safeEducation: {
          rules: [{
            required: true,
            message: '请选择作业类别!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择作业类别!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入有限空间名称!'
          }]
        },
        responsible: {
          rules: [{
            required: true,
            message: '请选择负责人!'
          }]
        },
        workUser: {
          rules: [{
            required: true,
            message: '请选择作业人员!'
          }]
        },
        accompanyUser: {
          rules: [{
            required: false,
            message: '请选择陪同人员!'
          }]
        },
        verifyUser: {
          rules: [{
            required: true,
            message: '请选择审核人!'
          }]
        },
        verifyState: {
          rules: [{
            required: false,
            message: '请审批!'
          }]
        },
        departId: {
          rules: [{
            required: true,
            message: '选择作业单位'
          }]
        },
        time: {
          rules: [{
            required: true,
            message: '请选择作业时间'
          }]
        }
      },
      url: {
        imageUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  components: {
    IwsUpload: IwsUpload,
    MapGetPoint: MapGetPoint
  },
  props: ['pagePath'],
  created: function created() {
    this.loadTree();
    this.loadTreeList();
  },
  methods: (_methods = {
    categoryChange: function categoryChange(value) {
      this.$set(this.model, 'category', value);
      this.$forceUpdate();
    },
    statusChange: function statusChange(value) {
      this.$set(this.model, 'safeEducation', value);
      this.$forceUpdate();
    },
    mapChangeLocation: function mapChangeLocation(value) {
      console.log('value', value);

      if (value != null) {
        this.form.setFieldsValue({
          addr: value
        });
      }
    },
    coordinateOk: function coordinateOk(value) {
      console.log('value', value); // if (value != null) {
      //   this.form.setFieldsValue({
      //     longitude: value[0] ? value[0] : null
      //   })
      //   this.form.setFieldsValue({
      //     latitude: value[1] ? value[1] : null
      //   })
      // }
    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    changeUpload: function changeUpload(value) {
      console.log('value', value);
      value.sysFileList.forEach(function (item, index) {
        item['fileSrc'] = 'om_work_safety';
      });
      value.fileDelList.forEach(function (item, index) {
        item['fileSrc'] = 'om_work_safety';
      });
    },
    changeDownUpload: function changeDownUpload(value) {
      console.log('value', value);
      value.sysFileList.forEach(function (item, index) {
        item['fileSrc'] = 'om_work_safety_txt';
      });
      value.fileDelList.forEach(function (item, index) {
        item['fileSrc'] = 'om_work_safety_txt';
      });
    }
  }, _defineProperty(_methods, "changeDownUpload", function changeDownUpload(value) {
    console.log('value', value);
    value.sysFileList.forEach(function (item, index) {
      item['fileSrc'] = 'om_work_safety_txt';
    });
    value.fileDelList.forEach(function (item, index) {
      item['fileSrc'] = 'om_work_safety_txt';
    });
  }), _defineProperty(_methods, "changeEducationUpload", function changeEducationUpload(value) {
    value.sysFileList.forEach(function (item, index) {
      item['fileSrc'] = 'om_work_safe_education';
    });
    value.fileDelList.forEach(function (item, index) {
      item['fileSrc'] = 'om_work_safe_education';
    });
  }), _defineProperty(_methods, "loadTree", function loadTree() {
    var _this = this;

    var that = this;
    that.deptTree = []; // 部门

    queryDepartTreeList().then(function (res) {
      if (res.success) {
        for (var i = 0; i < res.result.length; i++) {
          var temp = res.result[i];
          temp.isLeaf = true;
          delete temp.children;
          that.deptTree.push(temp);
        }

        console.log('that.deptTree', that.deptTree);
        _this.loading = false;
      }
    });
  }), _defineProperty(_methods, "loadTreeList", function loadTreeList() {
    var _this2 = this;

    var that = this;
    that.userTree = []; // 用户

    queryUserTreeList().then(function (res) {
      if (res.success) {
        for (var i = 0; i < res.result.length; i++) {
          var temp = res.result[i];
          that.userTree.push(temp);
        }

        _this2.loading = false;
      }
    });
  }), _defineProperty(_methods, "openFile", function openFile(text) {
    if (!text) {
      this.$message.warning('未知的文件');
      return;
    }

    this.imgId = this.getImgView(text);
    this.showImgModal = true;
  }), _defineProperty(_methods, "getImgView", function getImgView(text) {
    return this.url.imgerver + '/' + text;
  }), _defineProperty(_methods, "add", function add() {
    this.edit({});
  }), _defineProperty(_methods, "edit", function edit(record) {
    var _this3 = this;

    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    this.type = type;
    this.visible = true;
    this.$nextTick(function () {
      //debugger
      // 加载巡检模板列表
      _this3.form.resetFields();

      _this3.model = Object.assign({}, record);

      if (_this3.model.id) {
        console.log('this.model', _this3.model);
        _this3.model.workUser = _this3.model.workUser ? _this3.model.workUser.split(',') : null;
        _this3.model.accompanyUser = _this3.model.accompanyUser ? _this3.model.accompanyUser.split(',') : null;
      } else {
        _this3.model.verifyState = null;
        _this3.model.safeEducation = null;
        _this3.model.category = null;
      }

      if (_this3.model.feedback) {
        _this3.model.feedback = _this3.model.feedback.split(',');
      }

      _this3.$nextTick(function () {
        _this3.form.setFieldsValue(pick(_this3.model, _this3.form_fields)); // 时间格式化


        _this3.form.setFieldsValue({
          time: _this3.model.time ? moment(_this3.model.time) : null
        }); // this.$refs.iwupload.loadUploadFiles()
        // if(this.$refs.txtupload){
        //   this.$refs.txtupload.loadUploadFiles()
        // }

      });
    });
  }), _defineProperty(_methods, "handleOk", function handleOk() {
    var _this4 = this;

    console.log('enter that');
    var that = this; // 触发表单验证

    this.form.validateFields(function (err, values) {
      console.log('err', err);

      if (!err) {
        that.confirmLoading = true;
        var httpurl = '';
        var method = '';

        if (!_this4.model.id) {
          httpurl = _this4.url.add ? _this4.url.add : _this4.pagePath;
          method = 'post';
        } else {
          httpurl = _this4.url.edit ? _this4.url.edit : _this4.pagePath;
          method = 'put';
        }

        var formData = Object.assign(that.model, values);
        formData.time = formData.time ? moment(formData.time) : null;
        formData.time = formData.time ? formData.time.format('YYYY-MM-DD HH:mm:ss') : null;
        formData.accompanyUser = formData.accompanyUser ? formData.accompanyUser.join(',') : '';
        formData.workUser = formData.workUser ? formData.workUser.join(',') : '';
        console.log('formData', formData);
        formData = _this4.$refs.iwupload.getUploadListToFromData(formData);

        if (_this4.$refs.txtupload) {
          var datas = that.$refs.txtupload.getUploadListToFromData(JSON.parse(JSON.stringify(formData)));
          formData.sysFileList = formData.sysFileList.concat(datas.sysFileList);
          formData.fileDelList = formData.fileDelList.concat(datas.fileDelList);
        }

        if (_this4.$refs.iwuploadEducation) {
          var _datas = that.$refs.iwuploadEducation.getUploadListToFromData(JSON.parse(JSON.stringify(formData)));

          formData.sysFileList = formData.sysFileList.concat(_datas.sysFileList);
          formData.fileDelList = formData.fileDelList.concat(_datas.fileDelList);
        }

        if (_this4.type == 2) {
          formData.feedback = formData.feedback.join(',');
        }

        httpAction(httpurl, formData, method).then(function (res) {
          if (res.success) {
            that.$notification.success({
              message: res.message
            });
            that.$emit('ok');
            that.close();
          } else {
            that.$notification.warning({
              message: res.message
            });
          }
        }).finally(function () {
          that.confirmLoading = false;
        });
      }
    });
  }), _defineProperty(_methods, "close", function close() {
    this.hiddenButton = true; // 设为true 每次关闭重置  不影响确定按钮的&&

    this.$emit('close');
    this.visible = false;
  }), _methods)
};